import user from './units/user';
import customer from './units/customer';
import _service from './units/service';
import actionTest from './units/action-test';
import device from './units/device';
import palpation from './units/palpation';
import massage from './units/massage';
import system from './units/system';
import lanInterface from './units/lan-interface';
import serviceRecordApi from './units/service-record';
import AIDiagnose from './units/ai-diagnose';
import bodyMeasurementApi from './units/body-measurement';
import help from './units/help';
import upload from './units/upload';

const service = {
  user,
  customer,
  service: _service,
  actionTest,
  device,
  palpation,
  massage,
  system,
  lanInterface,
  serviceRecordApi,
  AIDiagnose,
  bodyMeasurementApi,
  help,
  upload,
};

export default service;
